import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType, concatLatestFrom } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import {
    goToDocumentReviewer,
    goToDocumentReviewerFromAssignedPages
} from 'src/app/compliance/store/actions/document-batch-details.actions';
import { goToBatchDetails, goToLegacyReassignPage } from 'src/app/compliance/store/actions/document-reviewer.actions';
import { selectComplianceRouteArgs } from 'src/app/compliance/store/selectors/compliance.selectors';
import { WINDOW } from 'src/app/core/core.module';

@Injectable()
export class ComplianceRoutingEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly _store: Store,
        private readonly _router: Router,
        @Inject(WINDOW) private readonly _window: Window
    ) {}

    goToDocReviewer$ = createEffect(
        () => {
            return this._actions$.pipe(
                ofType(goToDocumentReviewer),
                concatLatestFrom(() => this._store.select(selectComplianceRouteArgs)),
                map(([action, args]) => {
                    this._route(action.url, args);
                })
            );
        },
        { dispatch: false }
    );

    goToDocReviewerFromBatchDetails$ = createEffect(
        () => {
            return this._actions$.pipe(
                ofType(goToDocumentReviewerFromAssignedPages),
                concatLatestFrom(() => this._store.select(selectComplianceRouteArgs)),
                map(([action, args]) => {
                    this._route(action.url, args, false, action.documentId);
                })
            );
        },
        { dispatch: false }
    );

    goToBatchDetails$ = createEffect(
        () => {
            return this._actions$.pipe(
                ofType(goToBatchDetails),
                concatLatestFrom(() => this._store.select(selectComplianceRouteArgs)),
                map(([action, args]) => {
                    this._route(action.url, args, action.newTab);
                })
            );
        },
        { dispatch: false }
    );

    goToLegacyReassignPage$ = createEffect(
        () => {
            return this._actions$.pipe(
                ofType(goToLegacyReassignPage),
                map((action) => {
                    this._router.navigate([`/compliance/posted-docs/${action.documentId}/assign`]);
                })
            );
        },
        { dispatch: false }
    );

    private _route(route: string, args: any, newTab = false, documentId = 0) {
        const params: {
            assignedUploaderId: number;
            isSignedContract: boolean;
            isCandidateUpload: boolean;
            documentId?: number;
        } = {
            assignedUploaderId: args.uploaderId,
            isSignedContract: args.signedContract,
            isCandidateUpload: args.candidateUpload
        };

        if (documentId > 0) {
            params.documentId = documentId;
        }

        const url = this._router.serializeUrl(
            this._router.createUrlTree([`${route}/${args.candidateId}`], {
                queryParams: params
            })
        );

        if (newTab) {
            this._window.open(`#${url}`, '_blank');
        } else {
            this._router.navigateByUrl(url);
        }
    }
}
